
(function(){
"use strict";
if(window.__ddRespawnBooted) return;
window.__ddRespawnBooted=1;

var $=function(s,c){return (c||document).querySelector(s);},
    $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));},
    RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    rnd=function(a,b){return a+Math.random()*(b-a);},
    ri=function(a,b){return Math.floor(rnd(a,b+1));},
    cl=function(v,a,b){return v<a?a:v>b?b:v;},
    TAU=Math.PI*2;

/* ---------- nav ---------- */
var nav=$('#nav');
var onScroll=function(){ nav.classList.toggle('dd-is-stuck', window.scrollY>18); };
window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

/* ---------- reveal ---------- */
if('IntersectionObserver' in window){
  var ro=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('dd-is-in');
      $$('.dd-bar i',e.target).forEach(function(b){ b.style.width=b.dataset.w+'%'; });
      ro.unobserve(e.target);
    });
  },{rootMargin:'0px 0px -12% 0px',threshold:.12});
  $$('.dd-rv').forEach(function(el){ ro.observe(el); });
}else{
  $$('.dd-rv').forEach(function(el){ el.classList.add('dd-is-in'); });
  $$('.dd-bar i').forEach(function(b){ b.style.width=b.dataset.w+'%'; });
}

/* ---------- identicons ---------- */
$$('.dd-quote__av svg').forEach(function(svg){
  var seed=svg.dataset.seed,h=2166136261;
  for(var i=0;i<seed.length;i++){ h^=seed.charCodeAt(i); h=Math.imul(h,16777619); }
  var s=h>>>0, nx=function(){ s^=s<<13;s>>>=0;s^=s>>17;s^=s<<5;s>>>=0; return s/4294967296; };
  var pal=['#C9FF2E','#9FD117','#F2F3F0','#8B90A0'], ns='http://www.w3.org/2000/svg', frag=document.createDocumentFragment();
  for(var y=0;y<5;y++) for(var x=0;x<3;x++){
    if(nx()>.52) continue;
    var c=pal[Math.floor(nx()*pal.length)];
    [x,4-x].forEach(function(px){
      var r=document.createElementNS(ns,'rect');
      r.setAttribute('x',px*2);r.setAttribute('y',y*2);
      r.setAttribute('width',2);r.setAttribute('height',2);r.setAttribute('fill',c);
      frag.appendChild(r);
    });
  }
  svg.appendChild(frag);
});

/* ---------- price selector ---------- */
var buy=$('#buy'), totalVal=$('#totalVal'), totalNote=$('#totalNote'), bought=false;
var hasOrder=!!(buy&&totalVal&&totalNote);
function money(n){ return '£'+n.toFixed(2); }
function sync(pulse){
  if(!hasOrder) return;
  var r=$('input[name="plan"]:checked'); if(!r) return;
  var p=parseFloat(r.dataset.price), was=r.dataset.was?parseFloat(r.dataset.was):0;
  totalVal.innerHTML=money(p);
  /* v9: the note opens with the purchase type (in the plan colour); the price appears only here, never on the cards or the CTA */
  var kind=r.dataset.kind||(r.value==='sub'?'Membership':r.value==='stack'?'Bulk purchase':'Single purchase');
  var note='<span class="dd-ob-type">'+kind+'</span> ';
  if(was>p){ note+='Save <b class="dd-lime">'+money(was-p)+'</b><br><s>'+money(was)+'</s>'; }
  else { note+='One-time payment'; }
  if(r.value==='sub') note+=' · renews monthly';
  if(r.value==='stack') note+=' · 90 nights of cover';
  if(r.value==='solo') note+=' · 30 nights of cover';
  totalNote.innerHTML=note;
  /* W-9 (28 Oct 2026) sold-out state: a plan whose variant is unavailable (data-avail="false", set by snippets/respawn-buy.liquid)
     disables the button and reads OUT OF STOCK, with the Squad comms restock line under it. Picking an in-stock plan restores it. */
  var oos=r.dataset.avail==='false', oosNote=$('#oosNote');
  buy.disabled=oos;
  if(oos) buy.setAttribute('aria-disabled','true'); else buy.removeAttribute('aria-disabled');
  if(oosNote) oosNote.hidden=!oos;
  /* CTA copy is constant and has no price; leave it alone while an add-to-cart is in flight */
  if(oos) buy.textContent='OUT OF STOCK';
  else if(!bought && buy.getAttribute('aria-busy')!=='true') buy.textContent='Tap to RESPAWN';
  buy.dataset.label=r.dataset.label;
  /* v9: the CTA ring + glow take the selected plan's colour (solo / sub / stack, see .dd-buy[data-plan] in respawn-v9.css) */
  var box=buy.closest?buy.closest('.dd-buy'):null;
  if(box){
    box.setAttribute('data-plan',r.value);
    box.setAttribute('data-oos',oos?'1':'0');
    if(pulse&&!RM){
      box.classList.remove('dd-ob-pulse'); void box.offsetWidth; box.classList.add('dd-ob-pulse');
      clearTimeout(box._ddObT); box._ddObT=setTimeout(function(){ box.classList.remove('dd-ob-pulse'); },520);
    }
  }
}
$$('input[name="plan"]').forEach(function(i){ i.addEventListener('change',function(){bought=false;sync(true);}); });
sync();

/* ---------- toast + sparks ---------- */
var toast=$('#toast'), toastT=$('#toastT'), toastS=$('#toastS'), tTimer;
function showToast(t,s){
  if(!toast||!toastT||!toastS) return;
  toastT.textContent=t; toastS.textContent=s;
  toast.classList.add('dd-is-on'); clearTimeout(tTimer);
  tTimer=setTimeout(function(){ toast.classList.remove('dd-is-on'); },4200);
}
function sparks(el){
  if(RM) return;
  var r=el.getBoundingClientRect(), cx=r.left+r.width/2, cy=r.top+r.height/2;
  for(var i=0;i<26;i++){
    (function(){
      var s=document.createElement('span'); s.className='dd-spark';
      s.style.left=cx+'px'; s.style.top=cy+'px';
      s.style.background=Math.random()>.28?'#C9FF2E':'#F2F3F0';
      document.body.appendChild(s);
      var a=rnd(0,TAU), d=rnd(70,230);
      s.animate([{transform:'translate(-50%,-50%) scale(1)',opacity:1},
                 {transform:'translate('+(Math.cos(a)*d-4)+'px,'+(Math.sin(a)*d-4)+'px) scale(0)',opacity:0}],
                {duration:rnd(500,1000),easing:'cubic-bezier(.16,.9,.3,1)'}).onfinish=function(){ s.remove(); };
    })();
  }
}
if(hasOrder) buy.addEventListener('click',function(){
  bought=true;
  buy.innerHTML='Equipped ✓ · Welcome to the squad';
  sparks(buy);
  showToast('Item acquired · '+(buy.dataset.label||'RESPAWN'),'RESPAWN ×1 added to your loadout. You’re one of us now.');
  setTimeout(function(){ bought=false; sync(); },5200);
});

/* ============================================================
   ARENA — the battle
   ============================================================ */
var cv=$('#arena'); if(!cv) return;
var ctx=cv.getContext('2d',{alpha:true}), stage=$('#stage'), tower=$('#tower'), hero=$('#top');
var W=0,H=0,DPR=1,AX=0,AY=0,SHIELD=90,SPAWNR=420,SCALE=1,MOBILE=false;

/* v10 (22 Oct 2026): classic-arena enemy names relabelled from symptoms to late-night habits, matching the cartoon
   battle (DECISIONS v10). Only the n: strings changed; ids, stats and mechanics are untouched. */
var TYPES=[
 {id:'fog',  n:'DOOMSCROLL',  hp:133, sp:.34, r:21, c:'#8B90A0', k:'FOCUS LOCK'},
 {id:'lag',  n:'INPUT LAG',   hp:104, sp:.54, r:18, c:'#FF2E4D', k:'FOCUS LOCK'},
 {id:'3am',  n:'3AM QUEUE',   hp:174, sp:.30, r:23, c:'#FF2E4D', k:'SLEEP MODE'},
 {id:'tilt', n:'TILT',        hp:87, sp:.74, r:17, c:'#FF2E4D', k:'MUSCLE CHILL'},
 {id:'claw', n:'SWEATY LOBBY', hp:114, sp:.46, r:19, c:'#FF2E4D', k:'GRIP LOCK'},
 {id:'neck', n:'MARATHON SESH', hp:144, sp:.32, r:20, c:'#FF2E4D', k:'MUSCLE CHILL'},
 {id:'batt', n:'TIREDNESS',   hp:121, sp:.42, r:19, c:'#FF2E4D', k:'FATIGUE SLAYER'},
 {id:'grog', n:'FATIGUE',    hp:155, sp:.26, r:22, c:'#FF2E4D', k:'RAPID REGEN'},
 {id:'burn', n:'ALL-NIGHTER', hp:136, sp:.44, r:20, c:'#FF2E4D', k:'FATIGUE SLAYER'}
];
var BOSS={id:'debt',n:'ONE MORE GAME',hp:900,sp:.19,r:46,c:'#FF2E4D',k:'SLEEP MODE',boss:true};

var foes=[],shots=[],parts=[],nums=[],rings=[],beams=[];
var kills=0,streak=0,lastKill=0,chain=0,ultC=0,hp=100,wave=1,mins=167,shake=0,boss=null;
var tE=0,tR=0,tSpawn=0,tWave=0,tClock=0,tFire=0;

var el={feed:$('#feed'),kills:$('#kills'),clock:$('#clock'),hpBar:$('#hpBar'),ultBar:$('#ultBar'),
        wave:$('#wave'),callout:$('#callout'),boss:$('#boss'),bossName:$('#bossName'),bossHp:$('#bossHp'),
        q:$('#slotQ'),e:$('#slotE'),r:$('#slotR')};

/* pre-rendered glow sprites (shadowBlur is too costly per-entity) */
var glows={};
function rgba(hex,a){
  var n=parseInt(hex.slice(1),16);
  return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+a+')';
}
function glow(col){
  if(glows[col]) return glows[col];
  var s=128,c=document.createElement('canvas'); c.width=c.height=s;
  var g=c.getContext('2d'), rg=g.createRadialGradient(s/2,s/2,0,s/2,s/2,s/2);
  rg.addColorStop(0,rgba(col,.95)); rg.addColorStop(.28,rgba(col,.42));
  rg.addColorStop(.62,rgba(col,.12)); rg.addColorStop(1,rgba(col,0));
  g.fillStyle=rg; g.fillRect(0,0,s,s);
  glows[col]=c; return c;
}
function drawGlow(x,y,r,col,a){
  var g=glow(col); ctx.globalAlpha=a; ctx.globalCompositeOperation='lighter';
  ctx.drawImage(g,x-r,y-r,r*2,r*2);
  ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
}

function resize(){
  var r=hero.getBoundingClientRect();
  W=Math.max(1,Math.round(r.width)); H=Math.max(1,Math.round(r.height));
  DPR=Math.min(window.devicePixelRatio||1,2);
  cv.width=W*DPR; cv.height=H*DPR; cv.style.width=W+'px'; cv.style.height=H+'px';
  ctx.setTransform(DPR,0,0,DPR,0,0);
  var t=tower.getBoundingClientRect();
  AX=t.left-r.left+t.width/2; AY=t.top-r.top+t.height/2;
  SHIELD=Math.max(t.width,t.height)*.60;
  MOBILE=window.innerWidth<980;
  SCALE=cl(Math.min(W,H)/620,.62,1.15);
  var sr=stage.getBoundingClientRect();
  SPAWNR=MOBILE?cl(sr.width*.42,130,215):cl(Math.max(sr.width,sr.height)*.46,175,330);
  var mr=Math.round(SPAWNR*1.62);
  var mask='radial-gradient(circle '+mr+'px at '+Math.round(AX)+'px '+Math.round(AY)+'px,'+
           'rgba(0,0,0,1) 72%,rgba(0,0,0,.9) 84%,rgba(0,0,0,.34) 94%,rgba(0,0,0,0) 100%)';
  cv.style.webkitMaskImage=mask; cv.style.maskImage=mask;
}

function spawnDir(){
  if(MOBILE){
    /* flank the bottle from left and right, angled up — never down through the copy,
       never straight up into the nav */
    return Math.random()<.5 ? rnd(-0.78,0.30) : Math.PI+rnd(-0.30,0.78);
  }
  /* desktop: right hemisphere, wide enough to ring the bottle but clear of the headline */
  return (Math.random()*264-132)*Math.PI/180;
}
function spawn(t){
  var a=spawnDir(), d=SPAWNR+rnd(8,64);
  var r=t.r*SCALE;
  foes.push({t:t,x:AX+Math.cos(a)*d,y:AY+Math.sin(a)*d,r:r,hp:t.hp,max:t.hp,
             sp:t.sp*(MOBILE?.8:1),ph:rnd(0,TAU),fl:0,gl:0,kb:0,rot:rnd(0,TAU)});
  return foes[foes.length-1];
}

function feed(who,wep,vic,crit){
  if(!el.feed) return;
  var d=document.createElement('div');
  d.className='dd-feed__item'+(crit?' dd-is-crit':'');
  d.innerHTML='<span class="dd-who">'+who+'</span><span class="dd-wep">› '+wep+' ›</span><span class="dd-vic">'+vic+'</span>';
  el.feed.appendChild(d);
  while(el.feed.children.length>4) el.feed.removeChild(el.feed.firstChild);
  setTimeout(function(){ d.classList.add('dd-is-out'); setTimeout(function(){ if(d.parentNode) d.remove(); },400); },4200);
}
var coTimer;
function callout(txt,blood){
  if(!el.callout) return;
  el.callout.textContent=txt;
  el.callout.classList.toggle('dd-is-blood',!!blood);
  el.callout.classList.remove('dd-is-on'); void el.callout.offsetWidth; el.callout.classList.add('dd-is-on');
  clearTimeout(coTimer); coTimer=setTimeout(function(){ el.callout.classList.remove('dd-is-on'); },1600);
}

function hit(f,dmg,crit,src){
  f.hp-=dmg; f.fl=1;
  nums.push({x:f.x+rnd(-8,8),y:f.y-f.r-4,v:-.72,l:1,txt:(crit?'':'')+Math.round(dmg),crit:crit});
  if(f.hp<=0) die(f,src);
}
function die(f,src){
  var i=foes.indexOf(f); if(i<0) return;
  foes.splice(i,1);
  if(f===boss){ boss=null; el.boss.classList.remove('dd-is-on'); callout('BOSS EXECUTED · GG'); }
  kills++; el.kills.textContent=kills;
  ultC=cl(ultC+(f.t.boss?40:8),0,100); el.ultBar.style.width=ultC+'%';
  el.q.classList.toggle('dd-is-ready',ultC>=100);
  el.q.firstElementChild.style.setProperty('--cd',(1-ultC/100).toFixed(2));
  var now=performance.now();
  chain = (now-lastKill<1100)? chain+1 : 1; lastKill=now; streak++;
  feed('RESPAWN',src||f.t.k,f.t.n,!!f.crit);
  if(chain===2) callout('DOUBLE KILL');
  else if(chain===3) callout('TRIPLE KILL');
  else if(chain>=4) callout('RAMPAGE');
  else if(streak===10) callout('UNSTOPPABLE');
  else if(streak===20) callout('GODLIKE');
  for(var p=0;p<(f.t.boss?46:18);p++){
    var a=rnd(0,TAU),s=rnd(1.4,f.t.boss?7:4.6);
    parts.push({x:f.x,y:f.y,vx:Math.cos(a)*s,vy:Math.sin(a)*s,l:1,dl:rnd(.014,.034),
                c:Math.random()>.55?'#C9FF2E':f.t.c,s:rnd(1.6,3.6)});
  }
  rings.push({x:f.x,y:f.y,r:f.r*.7,mr:f.r*3.1,l:1,c:'#C9FF2E',w:2});
  nums.push({x:f.x,y:f.y-f.r-14,v:-.5,l:1.4,txt:'EXECUTED',big:true});
}

function fire(){
  var best=null,bd=1e9;
  for(var i=0;i<foes.length;i++){
    var d=Math.hypot(foes[i].x-AX,foes[i].y-AY);
    if(d<bd){ bd=d; best=foes[i]; }
  }
  if(!best) return;
  var a=Math.atan2(best.y-AY,best.x-AX)+rnd(-.05,.05);
  var off=SHIELD*.55;
  shots.push({x:AX+Math.cos(a)*off,y:AY+Math.sin(a)*off,vx:Math.cos(a)*9.4,vy:Math.sin(a)*9.4,
              tg:best,l:1,px:AX,py:AY});
}
function ult(){
  ultC=0; el.ultBar.style.width='0%'; el.q.classList.remove('dd-is-ready');
  rings.push({x:AX,y:AY,r:SHIELD,mr:Math.max(W,H)*.82,l:1,c:'#C9FF2E',w:5,kill:true});
  shake=13; callout('SLEEP MODE · TEAM WIPE');
  hp=cl(hp+22,0,100); el.hpBar.style.width=hp+'%';
  el.r.classList.add('dd-is-ready'); tR=0;
}
function focusBeam(){
  var best=null,bh=-1;
  for(var i=0;i<foes.length;i++) if(foes[i].hp>bh){ bh=foes[i].hp; best=foes[i]; }
  if(!best) return;
  beams.push({t:best,l:1});
  best.crit=true;
  hit(best,54,true,'FOCUS LOCK');
  tE=7.2;
}

/* ---------- enemy silhouettes ---------- */
function eyes(r,ang){
  ctx.fillStyle='#F2F3F0';
  ctx.beginPath(); ctx.ellipse(-r*.3,-r*.06,r*.17,r*.1,ang||0,0,TAU); ctx.fill();
  ctx.beginPath(); ctx.ellipse(r*.3,-r*.06,r*.17,r*.1,-(ang||0),0,TAU); ctx.fill();
}
function shape(f,t){
  var r=f.r,c=f.fl>0?'#FFFFFF':f.t.c;
  ctx.lineWidth=2.2; ctx.strokeStyle=c; ctx.fillStyle='#0B0D13';
  switch(f.t.id){
    case 'fog':
      ctx.beginPath();
      ctx.arc(-r*.45,r*.08,r*.56,0,TAU); ctx.arc(r*.06,-r*.3,r*.62,0,TAU);
      ctx.arc(r*.5,r*.1,r*.5,0,TAU); ctx.arc(0,r*.34,r*.5,0,TAU);
      ctx.fill(); ctx.stroke(); eyes(r,.32); break;
    case 'lag':
      ctx.globalAlpha=.55; ctx.fillStyle='#FF2E4D';
      ctx.fillRect(-r+Math.sin(t*22)*4,-r,r*2,r*2);
      ctx.fillStyle='#2EE8FF'; ctx.fillRect(-r-Math.sin(t*22)*4,-r,r*2,r*2);
      ctx.globalAlpha=1; ctx.fillStyle='#0B0D13';
      ctx.fillRect(-r,-r,r*2,r*2); ctx.strokeRect(-r,-r,r*2,r*2);
      eyes(r*.9); ctx.fillStyle=c;
      ctx.font='700 '+(r*.42).toFixed(0)+'px "Saira Condensed",sans-serif'; ctx.textAlign='center';
      ctx.fillText('999',0,r*.62); break;
    case '3am':
      ctx.beginPath(); ctx.arc(0,0,r,0,TAU); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(0,0); ctx.lineTo(0,-r*.6);
      ctx.moveTo(0,0); ctx.lineTo(r*.52,r*.14); ctx.lineWidth=2.6; ctx.stroke();
      ctx.lineWidth=2.2; eyes(r,.3); break;
    case 'tilt':
      ctx.beginPath();
      for(var i=0;i<10;i++){ var a=i/10*TAU-Math.PI/2, rr=i%2?r*.46:r;
        ctx[i?'lineTo':'moveTo'](Math.cos(a)*rr,Math.sin(a)*rr); }
      ctx.closePath(); ctx.fill(); ctx.stroke(); eyes(r*.72,.5); break;
    case 'claw':
      ctx.beginPath();
      ctx.moveTo(-r*.9,r*.7); ctx.quadraticCurveTo(-r*1.05,-r*.5,-r*.36,-r);
      ctx.quadraticCurveTo(-r*.2,-r*.2,0,-r*.9);
      ctx.quadraticCurveTo(r*.2,-r*.2,r*.36,-r);
      ctx.quadraticCurveTo(r*1.05,-r*.5,r*.9,r*.7);
      ctx.quadraticCurveTo(0,r*1.15,-r*.9,r*.7);
      ctx.closePath(); ctx.fill(); ctx.stroke(); eyes(r*.66); break;
    case 'neck':
      ctx.beginPath();
      ctx.moveTo(-r*.8,-r); ctx.lineTo(r*.2,-r*.32); ctx.lineTo(-r*.24,-r*.06);
      ctx.lineTo(r*.86,r); ctx.lineTo(-r*.2,r*.28); ctx.lineTo(r*.22,0);
      ctx.closePath(); ctx.fill(); ctx.stroke(); eyes(r*.6); break;
    case 'batt':
      ctx.beginPath(); ctx.roundRect?ctx.roundRect(-r,-r*.66,r*1.8,r*1.32,4):ctx.rect(-r,-r*.66,r*1.8,r*1.32);
      ctx.fill(); ctx.stroke();
      ctx.fillRect(r*.82,-r*.24,r*.24,r*.48);
      ctx.fillStyle=c; ctx.globalAlpha=.55+Math.sin(t*9)*.42;
      ctx.fillRect(-r*.82,-r*.44,r*.42,r*.88); ctx.globalAlpha=1;
      ctx.fillStyle='#F2F3F0';
      ctx.beginPath(); ctx.ellipse(r*.06,-r*.12,r*.13,r*.08,0,0,TAU); ctx.fill();
      ctx.beginPath(); ctx.ellipse(r*.5,-r*.12,r*.13,r*.08,0,0,TAU); ctx.fill(); break;
    case 'grog':
      ctx.beginPath();
      ctx.moveTo(-r,r*.5);
      ctx.bezierCurveTo(-r*1.05,-r*.7,r*1.05,-r*.7,r,r*.5);
      ctx.bezierCurveTo(r*.72,r*.92+Math.sin(t*3)*2,-r*.72,r*.92,-r,r*.5);
      ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(-r*.5,-r*.1); ctx.lineTo(-r*.1,-r*.1);
      ctx.moveTo(r*.1,-r*.1); ctx.lineTo(r*.5,-r*.1);
      ctx.strokeStyle='#F2F3F0'; ctx.lineWidth=2.4; ctx.stroke(); break;
    case 'burn':
      ctx.beginPath();
      ctx.moveTo(0,-r*1.1);
      ctx.bezierCurveTo(r*.86,-r*.3,r*.62,r*.62,0,r);
      ctx.bezierCurveTo(-r*.62,r*.62,-r*.86,-r*.3,0,-r*1.1);
      ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.globalAlpha=.4+Math.sin(t*11)*.3; ctx.fillStyle=c;
      ctx.beginPath(); ctx.moveTo(0,-r*.42);
      ctx.bezierCurveTo(r*.4,r*.06,r*.28,r*.5,0,r*.68);
      ctx.bezierCurveTo(-r*.28,r*.5,-r*.4,r*.06,0,-r*.42);
      ctx.fill(); ctx.globalAlpha=1; eyes(r*.56); break;
    default:
      ctx.beginPath();
      ctx.moveTo(0,-r); ctx.lineTo(r*.9,-r*.34); ctx.lineTo(r*.62,r*.84);
      ctx.lineTo(-r*.62,r*.84); ctx.lineTo(-r*.9,-r*.34);
      ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.fillStyle='#F2F3F0';
      ctx.beginPath(); ctx.arc(0,-r*.1,r*.3,0,TAU); ctx.fill();
      ctx.fillStyle='#FF2E4D';
      ctx.beginPath(); ctx.arc(0,-r*.1,r*.14,0,TAU); ctx.fill();
  }
}

function drawFoe(f,t){
  var jx=0,jy=0;
  if(f.t.id==='lag' && Math.sin(t*7+f.ph)>.86){ jx=rnd(-9,9); jy=rnd(-9,9); }
  var x=f.x+jx,y=f.y+jy;
  drawGlow(x,y,f.r*2.5,f.t.id==='fog'?'#8B90A0':'#FF2E4D',f.t.boss?.34:.2);
  ctx.save(); ctx.translate(x,y);
  if(f.t.id==='tilt') ctx.rotate(t*2.6+f.ph);
  else if(f.t.id==='3am') ctx.rotate(Math.sin(t*1.1+f.ph)*.22);
  else ctx.rotate(Math.sin(t*1.5+f.ph)*.09);
  shape(f,t); ctx.restore();

  /* nameplate + hp */
  var bw=Math.max(40,f.r*2.3), by=y-f.r-(f.t.boss?26:17);
  var nx=cl(x,bw/2+6,W-bw/2-6);
  ctx.font='700 '+(f.t.boss?13:10.5).toFixed(0)+'px "Saira Condensed",sans-serif';
  ctx.textAlign='center'; ctx.textBaseline='alphabetic';
  try{ ctx.letterSpacing='1.4px'; }catch(e){}
  ctx.fillStyle=f.t.boss?'#FF2E4D':'rgba(242,243,240,.88)';
  ctx.fillText(f.t.n,nx,by);
  try{ ctx.letterSpacing='0px'; }catch(e){}
  ctx.fillStyle='rgba(242,243,240,.14)'; ctx.fillRect(nx-bw/2,by+4,bw,3);
  ctx.fillStyle=f.t.boss?'#FF2E4D':'#FF6B80';
  ctx.fillRect(nx-bw/2,by+4,bw*cl(f.hp/f.max,0,1),3);
}

function drawShield(t){
  ctx.save(); ctx.translate(AX,AY);
  drawGlow(0,0,SHIELD*2.3,'#C9FF2E',.16);
  ctx.rotate(t*.36);
  ctx.strokeStyle='rgba(201,255,46,'+(.34+Math.sin(t*2)*.1)+')'; ctx.lineWidth=1.6;
  ctx.setLineDash([16,11]); ctx.beginPath(); ctx.arc(0,0,SHIELD,0,TAU); ctx.stroke();
  ctx.setLineDash([]); ctx.rotate(-t*.72);
  ctx.strokeStyle='rgba(201,255,46,.16)'; ctx.lineWidth=1;
  ctx.beginPath(); ctx.arc(0,0,SHIELD*1.28,0,TAU); ctx.stroke();
  ctx.setLineDash([3,9]);
  ctx.beginPath(); ctx.arc(0,0,SHIELD*.74,0,TAU); ctx.stroke();
  ctx.setLineDash([]); ctx.restore();
}

/* ---------- sim ---------- */
function step(dt,t){
  /* clock */
  tClock+=dt;
  if(tClock>2.1){ tClock=0; mins++; if(mins>=240) mins=167;
    el.clock.textContent=String(Math.floor(mins/60)).padStart(2,'0')+':'+String(mins%60).padStart(2,'0'); }

  /* waves */
  tWave+=dt;
  if(tWave>17){ tWave=0; wave++; el.wave.textContent=String(wave).padStart(2,'0');
    if(wave%3===0 && !boss){
      boss=spawn(BOSS); boss.r=BOSS.r*SCALE;
      el.bossName.textContent=BOSS.n; el.boss.classList.add('dd-is-on');
      callout('WARNING · '+BOSS.n,true);
    }
  }
  if(boss) el.bossHp.style.width=cl(boss.hp/boss.max*100,0,100)+'%';

  /* spawning */
  tSpawn-=dt;
  var cap=MOBILE?6:11;
  if(tSpawn<=0 && foes.length<cap){ tSpawn=rnd(.46,1.05); spawn(TYPES[ri(0,TYPES.length-1)]); }

  /* abilities */
  tE-=dt; if(tE<=0 && foes.length){ focusBeam(); }
  el.e.firstElementChild.style.setProperty('--cd',cl(tE/7.2,0,1).toFixed(2));
  el.e.classList.toggle('dd-is-ready',tE<=0);
  tR-=dt;
  if(tR<=0){ hp=cl(hp+9,0,100); el.hpBar.style.width=hp+'%';
    if(hp<100) rings.push({x:AX,y:AY,r:SHIELD*.5,mr:SHIELD*1.2,l:1,c:'#C9FF2E',w:2});
    tR=5.5; }
  el.r.firstElementChild.style.setProperty('--cd',cl(tR/5.5,0,1).toFixed(2));
  el.r.classList.toggle('dd-is-ready',tR<.4);
  if(ultC>=100) ult();

  /* fire */
  tFire-=dt; if(tFire<=0){ tFire=MOBILE?.3:.24; fire(); }

  /* foes */
  for(var i=foes.length-1;i>=0;i--){
    var f=foes[i], dx=AX-f.x, dy=AY-f.y, d=Math.hypot(dx,dy)||1;
    var stop=SHIELD+f.r*.82;
    if(f.kb>0){ f.x-=dx/d*f.kb*dt*60; f.y-=dy/d*f.kb*dt*60; f.kb*=.86; }
    if(d>stop){
      var sp=f.sp*170*dt*SCALE;
      var perp=Math.sin(t*2.1+f.ph)*30*dt*SCALE;
      f.x+=(dx/d)*sp - (dy/d)*perp; f.y+=(dy/d)*sp + (dx/d)*perp;
    }else{
      if(!f.touch){ f.touch=.6; hp=cl(hp-(f.t.boss?7:3),12,100); el.hpBar.style.width=hp+'%';
        el.hpBar.parentNode.classList.toggle('dd-is-blood',hp<42);
        stage.classList.add('dd-is-hit'); setTimeout(function(){ stage.classList.remove('dd-is-hit'); },300);
        f.kb=5.5; shake=Math.max(shake,4);
        rings.push({x:f.x,y:f.y,r:6,mr:f.r*2.2,l:1,c:'#FF2E4D',w:2});
        nums.push({x:f.x,y:f.y-f.r,v:-.6,l:1,txt:'BLOCKED',blocked:true});
      }
    }
    if(f.touch){ f.touch-=dt; if(f.touch<=0) f.touch=0; }
    if(f.fl>0) f.fl-=dt*7;
    if(Math.hypot(f.x-AX,f.y-AY)>SPAWNR*2.2) foes.splice(i,1);
  }

  /* shots */
  for(var s=shots.length-1;s>=0;s--){
    var b=shots[s]; b.px=b.x; b.py=b.y;
    if(b.tg && foes.indexOf(b.tg)>=0){
      var a=Math.atan2(b.tg.y-b.y,b.tg.x-b.x), ca=Math.atan2(b.vy,b.vx);
      var na=ca+Math.max(-.16,Math.min(.16,Math.atan2(Math.sin(a-ca),Math.cos(a-ca))));
      b.vx=Math.cos(na)*9.4; b.vy=Math.sin(na)*9.4;
    }
    b.x+=b.vx*dt*60; b.y+=b.vy*dt*60;
    var gone=true;
    for(var j=0;j<foes.length;j++){
      var g=foes[j];
      if(Math.hypot(b.x-g.x,b.y-g.y)<g.r+4){
        var crit=Math.random()<.17; g.crit=crit;
        hit(g,crit?rnd(46,62):rnd(19,28),crit,g.t.k);
        parts.push({x:b.x,y:b.y,vx:rnd(-2,2),vy:rnd(-2,2),l:1,dl:.07,c:'#C9FF2E',s:2.4});
        shots.splice(s,1); gone=false; break;
      }
    }
    if(gone && (b.x<-60||b.x>W+60||b.y<-60||b.y>H+60)) shots.splice(s,1);
  }

  /* rings */
  for(var k=rings.length-1;k>=0;k--){
    var R=rings[k]; R.r+=(R.mr-R.r)*Math.min(1,dt*4.6); R.l-=dt*1.25;
    if(R.kill){
      for(var q=foes.length-1;q>=0;q--){
        var fo=foes[q];
        if(Math.abs(Math.hypot(fo.x-AX,fo.y-AY)-R.r)<fo.r+26) hit(fo,fo.t.boss?230:400,true,'SLEEP MODE');
      }
    }
    if(R.l<=0) rings.splice(k,1);
  }
  /* beams */
  for(var m=beams.length-1;m>=0;m--){ beams[m].l-=dt*3.4; if(beams[m].l<=0) beams.splice(m,1); }
  /* particles */
  for(var p=parts.length-1;p>=0;p--){
    var P=parts[p]; P.x+=P.vx*dt*60; P.y+=P.vy*dt*60; P.vx*=.955; P.vy*=.955; P.vy+=dt*7;
    P.l-=P.dl*dt*60; if(P.l<=0) parts.splice(p,1);
  }
  /* numbers */
  for(var n=nums.length-1;n>=0;n--){
    var N=nums[n]; N.y+=N.v*dt*60; N.v*=.975; N.l-=dt*1.1; if(N.l<=0) nums.splice(n,1);
  }
  if(shake>0) shake=Math.max(0,shake-dt*34);
}

function render(t){
  ctx.clearRect(0,0,W,H);
  var sx=shake?rnd(-shake,shake):0, sy=shake?rnd(-shake,shake):0;
  ctx.save(); ctx.translate(sx,sy);

  drawShield(t);

  /* rings */
  rings.forEach(function(R){
    ctx.globalAlpha=Math.max(0,R.l)*.9; ctx.strokeStyle=R.c; ctx.lineWidth=R.w;
    ctx.beginPath(); ctx.arc(R.x,R.y,R.r,0,TAU); ctx.stroke(); ctx.globalAlpha=1;
  });

  foes.forEach(function(f){ drawFoe(f,t); });

  /* beams */
  beams.forEach(function(B){
    if(foes.indexOf(B.t)<0) return;
    ctx.globalAlpha=Math.max(0,B.l); ctx.globalCompositeOperation='lighter';
    ctx.strokeStyle='#C9FF2E'; ctx.lineWidth=1+B.l*4;
    ctx.beginPath(); ctx.moveTo(AX,AY); ctx.lineTo(B.t.x,B.t.y); ctx.stroke();
    ctx.globalCompositeOperation='source-over'; ctx.globalAlpha=1;
  });

  /* shots */
  ctx.globalCompositeOperation='lighter';
  shots.forEach(function(b){
    ctx.strokeStyle='rgba(201,255,46,.75)'; ctx.lineWidth=2.4; ctx.lineCap='round';
    ctx.beginPath(); ctx.moveTo(b.px,b.py); ctx.lineTo(b.x,b.y); ctx.stroke();
    ctx.fillStyle='#EAFFB0'; ctx.beginPath(); ctx.arc(b.x,b.y,2.6,0,TAU); ctx.fill();
  });
  /* particles */
  parts.forEach(function(P){
    ctx.globalAlpha=Math.max(0,P.l); ctx.fillStyle=P.c;
    ctx.fillRect(P.x-P.s/2,P.y-P.s/2,P.s,P.s);
  });
  ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';

  /* damage numbers */
  ctx.textAlign='center';
  nums.forEach(function(N){
    ctx.globalAlpha=Math.max(0,Math.min(1,N.l));
    if(N.big){ ctx.font='900 15px "Saira Condensed",sans-serif'; ctx.fillStyle='#C9FF2E'; }
    else if(N.blocked){ ctx.font='700 12px "Saira Condensed",sans-serif'; ctx.fillStyle='#FF2E4D'; }
    else if(N.crit){ ctx.font='900 21px "Saira Condensed",sans-serif'; ctx.fillStyle='#EAFFB0'; }
    else { ctx.font='700 14px "Saira Condensed",sans-serif'; ctx.fillStyle='rgba(242,243,240,.9)'; }
    ctx.fillText(N.txt,N.x,N.y);
  });
  ctx.globalAlpha=1;
  ctx.restore();
}

/* ---------- click to execute ---------- */
hero.addEventListener('click',function(ev){
  if(ev.target.closest('a,button,input,label')) return;
  var r=cv.getBoundingClientRect(), x=ev.clientX-r.left, y=ev.clientY-r.top, best=null,bd=54;
  foes.forEach(function(f){ var d=Math.hypot(f.x-x,f.y-y); if(d<Math.max(bd,f.r+18)&&d<bd+f.r){ bd=d; best=f; } });
  if(best){ best.crit=true; hit(best,999,true,'HEADSHOT'); }
  else rings.push({x:x,y:y,r:3,mr:34,l:1,c:'rgba(242,243,240,.5)',w:1.5});
});
stage.style.cursor='crosshair';

/* ---------- loop ---------- */
var last=0,running=true,started=false;
function frame(now){
  if(!running) return;
  var dt=Math.min(.05,(now-last)/1000||.016); last=now;
  step(dt,now/1000); render(now/1000);
  requestAnimationFrame(frame);
}
function boot(){
  resize();
  el.hpBar.style.width=hp+'%';
  if(RM){
    for(var i=0;i<460;i++) step(.016,i*.016);
    render(7.4);
    return;
  }
  if(!started){ started=true; last=performance.now(); requestAnimationFrame(frame); }
}
var rt;
window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(function(){ resize(); if(RM) render(7.4); },160); });

if('IntersectionObserver' in window && !RM){
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){ if(!running){ running=true; last=performance.now(); requestAnimationFrame(frame); } }
      else running=false;
    });
  },{threshold:0}).observe(hero);
}

if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ resize(); if(RM) render(7.4); }); }
boot();
})();